// Data-tab parish toggle for the Lookup Tool compare view (?comparisonId=).
//
// In compare mode the Data tab renders two extremes tables — one per parish — and a
// radio group switches which is shown. Progressive enhancement: without JS both panels
// render stacked (a <noscript> style un-hides them); with JS we hide all but the
// selected one and let the radios toggle. Mirrors the pattern in tabs.js.

const parishDataToggleRadios = document.querySelectorAll("[data-parish-data-radio]");
const parishDataPanels = document.querySelectorAll("[data-parish-data-panel]");

if (parishDataToggleRadios.length && parishDataPanels.length) {
  const showParishDataPanel = (key) => {
    parishDataPanels.forEach((panel) => {
      panel.hidden = panel.getAttribute("data-parish-data-panel") !== key;
    });
  };

  parishDataToggleRadios.forEach((radio) => {
    radio.addEventListener("change", () => {
      if (radio.checked) showParishDataPanel(radio.getAttribute("data-parish-data-radio"));
    });
  });

  // Sync to whichever radio is checked on load (default: the primary parish).
  const checkedParishDataRadio = document.querySelector("[data-parish-data-radio]:checked");
  showParishDataPanel(
    checkedParishDataRadio ? checkedParishDataRadio.getAttribute("data-parish-data-radio") : "primary",
  );
}
